module.exports = __webpack_public_path__ + "img/3_26@2x.c55d2e2e.png";